// CssVarsProvider.js
import { createTheme } from "@mui/material";
import {lightColorScheme} from "./theme";

const customTheme = createTheme(lightColorScheme);

export default customTheme;
